import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from '@store/reducers';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUserLoading = createSelector(
  selectUserState,
  (state: UserState) => state.loading
);

export const selectUserEditMode = createSelector(
  selectUserState,
  (state: UserState) => state.editMode
);

export const selectUserIsEditing = createSelector(
  selectUserState,
  (state: UserState) => state.isEditing
);

export const selectUserId = createSelector(
  selectUserState,
  (state: UserState) => state.userId
);

export const selectUser = createSelector(
  selectUserState,
  (state: UserState) => state.user
);

export const selectUserList = createSelector(
  selectUserState,
  (state: UserState) => state.userList
);

export const selectUserForm = createSelector(
  selectUserState,
  (state: UserState) => state.userForm
);

export const selectUserError = createSelector(
  selectUserState,
  (state: UserState) => state.error
);